<!--  -->
<template>
  <div>
    <!-- 登录弹出框 -->
    <el-dialog
      :visible.sync="qrcode"
      center
      :modal="false"
      custom-class="login-dialog"
      :show-close="false"
    >
      <div class="tab_con" v-show="currentTab == 0">
        <div class="qrcode-wrap">
          <img :src="qrcodeUrl" alt="" class="qrcode" />
          <div class="qrcode-modal" v-if="isShow == true">
            <el-button circle class="refresh-btn" @click="refreshQr">
              <i class="iconfont">&#xe65d;</i>
            </el-button>
          </div>
        </div>

        <el-row class="text-tips">
          <div v-if="isShow == false">
            <i class="iconfont" style="color: #ff7919; margin-right: 5px">&#xe637;</i>
            <span>打开微信扫一扫，立即注册或登录</span>
          </div>
          <div v-if="isShow == true">
            <span>二维码已过期，请重新获取</span>
          </div>
        </el-row>
      </div>
      <div class="tab_con" v-show="currentTab == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          :label-position="labelPosition"
        >
          <el-form-item label="账号" prop="account">
            <el-input
              v-model="ruleForm.account"
              autocomplete="off"
              onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
              maxlength="11"
              class="noBorder-input"
              placeholder="请输入账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
              class="noBorder-input"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>

          <el-button size="medium" type="primary" class="login-btn" @click="accountLogin"
            >登录</el-button
          >
        </el-form>
      </div>
      <div class="tab_con" v-show="currentTab == 2">
        <el-form
          :model="ruleFormPhone"
          ref="ruleFormPhone"
          label-width="100px"
          class="demo-ruleForm"
          :label-position="labelPosition"
        >
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              autocomplete="off"
              onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
              maxlength="11"
              class="noBorder-input"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="verifi">
            <el-input
              v-model="ruleForm.verifi"
              autocomplete="off"
              onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
              maxlength="5"
              class="noBorder-input"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              class="getVerifi"
              type="text"
              @click="sendMsg"
              :disabled="isDisabled"
              >{{ buttonName }}</el-button
            >
          </el-form-item>

          <el-button size="medium" type="primary" class="login-btn" @click="loginCode"
            >登录</el-button
          >
        </el-form>
      </div>

      <div class="tab">
        <ul class="tab_button">
          <li
            v-for="(item, index) in tabList"
            :key="index"
            :class="{ active: currentClass == index }"
            @click="toggleTab(index)"
          >
            <i class="iconfont">{{ item.iconContent }}</i>
            {{ item.tabName }}
          </li>
        </ul>
      </div>
    </el-dialog>

    <!-- 填写信息弹出框 -->
    <el-dialog
      :visible.sync="userInfoDia"
      center
      :modal="false"
      custom-class="login-dialog"
      :show-close="false"
    >
      <div class="jump" @click="userDia">
        <img src="../../assets/images/userImg.png" alt="" />
        <div class="title-tips">已有账号，直接登录</div>
      </div>

      <el-form
        :model="ruleFormUser"
        ref="ruleFormUser"
        label-width="100px"
        class="demo-ruleForm"
        :label-position="labelPosition"
      >
        <el-form-item label="昵称" prop="nickName">
          <el-input
            type="text"
            v-model="ruleFormUser.nickName"
            autocomplete="off"
            class="noBorder-input"
            placeholder="请输入昵称"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model="ruleFormUser.phone"
            autocomplete="off"
            class="noBorder-input"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="verifi">
          <el-input
            v-model="ruleFormUser.verifi"
            autocomplete="off"
            onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
            maxlength="5"
            class="noBorder-input"
            placeholder="请输入验证码"
          ></el-input>
          <el-button
            class="getVerifi"
            type="text"
            @click="sendMsg2"
            :disabled="isDisabled2"
            >{{ buttonName2 }}</el-button
          >
        </el-form-item>
        <el-form-item label="密码" prop="pass">
          <el-input
            type="password"
            v-model="ruleFormUser.passWord"
            autocomplete="off"
            class="noBorder-input"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="conPass">
          <el-input
            type="password"
            v-model="ruleFormUser.conPass"
            autocomplete="off"
            class="noBorder-input"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>

        <el-button size="medium" type="primary" class="login-btn" @click="subInfo"
          >完成注册</el-button
        >
      </el-form>
    </el-dialog>

      <!-- 完善信息弹出框 -->
    <el-dialog 
     :visible.sync="writeinfo"
     :show-close="false"
     :modal="false"
     center
     width="400px"
     height="606px"
     custom-class="profile"
    >
      <div style="text-align: center;margin-bottom: 10px;">
        <div class="head">编辑资料</div>
        <div class="headtip">编辑您的雷兔资料方便与同行交流</div>
      </div>
      <el-form :model="formprofile" status-icon label-position="right" :rules="rules2" ref="formprofile" label-width="80px">
       
        <el-form-item label="行业:" prop="value1">
            <el-select
             v-model="formprofile.value1"
              multiple
              class="my-el-select"
              collapse-tags
              placeholder="请选择行业" 
             >
              <el-option
                v-for="item in showTypeList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>


        </el-form-item>
        <el-form-item label="类型:" prop="value2">
          
            <el-select
             v-model="formprofile.value2"
              multiple
              class="my-el-select"
              collapse-tags
              placeholder="请选择类型">
              <el-option
                v-for="item in pushrangeList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>

        </el-form-item>
        <el-form-item label="所在地:" prop="selectedOptions">
          <el-cascader
            size="small"
            :options="options"
            v-model="formprofile.selectedOptions"
            @change="handleChange"
            style="width: 260px"
          >
          </el-cascader>
        </el-form-item>

         <el-form-item label="微信:" prop="wx" >
          <el-input v-model="formprofile.wx" class="my-input" placeholder="联系微信" autocomplete="off"></el-input>
        </el-form-item>
         <el-form-item label="QQ:" prop="qq" >
          <el-input v-model="formprofile.qq" class="my-input" placeholder="联系QQ" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="自我介绍:" prop="desc">
          <el-input type="textarea" v-model="formprofile.desc" class="my-textarea"  placeholder="100字以内的简介" ></el-input>
        </el-form-item>
         <el-form-item>
            <el-button class="login_jump"  @click="cancelsubmit">跳过</el-button>
            <el-button class="login-btn2" type="primary"  @click="onSubmit('formprofile')">提交</el-button>
         </el-form-item>
      </el-form>
    </el-dialog>
   
  </div>
</template>

<script>
// @ts-nocheck
import "../../styles/common.css";
import Cookies from "js-cookie";
import { getqrcode, checklogin, sendcode, codelogin, passlogin,saveinfo } from "@/api/login.js";
import {
  showType,
  pushrange,
  region,
  editPersonal
} from "@/api/personal.js";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode,
} from "element-china-area-data";

export default {
  data() {
    var account = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("账号不能为空"));
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.pass !== "") {
          this.$refs.ruleForm.validateField("pass");
        }
        callback();
      }
    };
    //行业验证
    var catgoryPass = (rule, value, callback) => {
      if(value.length > 2){
         callback(new Error("行业最多选择2个"));
      }else{
       callback();
      }
    };
    //推广方式验证
    var pushrangePass = (rule, value, callback) => {
      // console.log("类型",value);
      // if (value.length <=0) {
      //   callback(new Error("请选择类型"));
      // } else {
        callback();
      // }
    };
    //微信验证
    var wxPass = (rule, value, callback) => {
      // console.log("微信",value,this.formprofile.wx);
      // if (!value) {
      //   return callback(new Error("微信号不能为空"));
      // }else{
        callback();
      // }
    };

    return {
      qrcode: false,
      userInfoDia: false,
      myinfo:{},//个人资料
      showTypeList: [],//行业选择
      pushrangeList :[],//推广方式
      cityList: [],
      options: regionData,
    
      formprofile: {
          wx:'',
          qq:'',
          desc: '',
          value1:[],//行业
          value2:[],//推广方式
          selectedOptions:[],
      },
    
      currentTab: 0,
      currentClass: 0,
      tabList: [
        {
          tabName: "扫码登录",
          iconContent: "\ue637",
        },
        {
          tabName: "密码登录",
          iconContent: "\ue638",
        },
        {
          tabName: "验证码登录",
          iconContent: "\ue636",
        },
      ],

      labelPosition: "left",
      ruleForm: {
        account: "",
        pass: "",
      },
      rules: {
        account: [{ validator: account, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }]
      },
      rules2:{
          value1:[{ validator: catgoryPass, trigger: "blur" }],
          value2:[{ validator: pushrangePass, trigger: "blur" }],
          wx:[{validator: wxPass, trigger: "blur" }]
      },
      ruleFormPhone: {
        phone: "",
        verifi: "",
      },
      ruleFormUser: {
        nickName: "",
        phone: "",
        verifi: "",
        passWord: "",
        conPass: "",
      },
      buttonName: "获取验证码",
      buttonName2: "获取验证码",
      isDisabled: false,
      isDisabled2: false,
      time: 60,
      qrcodeUrl: "",
      sceneId: "",
      timer: null,
      count: "",
      timeCount: null,
      isShow: false,
      invalid: "",
      isBinding: "",
      codeLogin: "",
      shareuid:'',
      writeinfo:false,//填写个人资料
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.getShowType();//行业类型
    this.getPushRange();//推广方式
    this.getRegion();//城市

    console.log("shareid",Cookies.get("shareuid"));
    if(Cookies.get("shareuid") && Cookies.get("shareuid") != 'undefined'){
      this.shareuid = Cookies.get("shareuid")
    }else{
      this.shareuid = ''
    }
  },
  methods: {
    //点击取消
    cancelsubmit(res){
        this.writeinfo = false;
        location.reload();
    },
    onSubmit(formName){
      
      this.$refs[formName].validate((valid) => {
           console.log(this.formprofile);
            if (valid) {
              var fromdata = {};
              if(this.formprofile.selectedOptions.length > 0){
                  var dz = CodeToText[this.formprofile.selectedOptions[0]] + "," + CodeToText[this.formprofile.selectedOptions[1]] + "," + CodeToText[this.formprofile.selectedOptions[2]];
                  var citarr = dz.split(',');
                  fromdata.province = citarr[0];
                  fromdata.city = citarr[1];
                  fromdata.area = citarr[2];
              }
              if(this.formprofile.value1){
                fromdata.showtype = this.formprofile.value1.join(',');
              }
              if(this.formprofile.value2){
                fromdata.pushrange = this.formprofile.value2.join(',');
              }

              if(this.formprofile.qq){
                fromdata.qq = this.formprofile.qq;
              }
              if(this.formprofile.wx){
                fromdata.wx = this.formprofile.wx;
              }

              if(this.formprofile.desc){
                fromdata.desc = this.formprofile.desc;
              }

              if(fromdata){
                fromdata.uid = this.userInfoId;
              }

               editPersonal(fromdata).then((res) => {
                  console.log(res);
                  if (res.code == 800) {
                    this.$message({
                      message: "保存成功",
                      type: "success"
                    });
                  }

                  setTimeout(() => {
                    location.reload();
                  }, 1000);

                });

            } else {
              return false;
            }
        });
      },

      getRegion() {
        region({}).then((res) => {
          this.cityList = res.data;
        });
      },
      handleChange(value) {

        console.log("城市",value);

        // if (value[1] != null && value[2] != null) {
        //   var dz =
        //     CodeToText[value[0]] + "," + CodeToText[value[1]] + "," + CodeToText[value[2]];
        //   this.addressid = value[2];
        // } else {
        //   if (value[1] != null) {
        //     dz = CodeToText[value[0]] + "," + CodeToText[value[1]];
        //     this.addressid = value[1];
        //   } else {
        //     dz = CodeToText[value[0]];
        //     this.addressid = value[0];
        //   }
        // }
        // this.address = dz;
        // var result = this.address.split(",");
        // for (var i = 0; i < result.length; i++) {
        //   this.province = result[0];
        //   this.city = result[1];
        //   this.area = result[2];
        // }
      },

    //推广方式
    getPushRange() {
      pushrange({}).then((res) => {
        this.pushrangeList = res.data;
      });
    },
    //获取行业
    getShowType() {
      showType({}).then((res) => {
        this.showTypeList = res.data;
      });
    },

    toggleTab(current) {
      this.currentTab = current;
      this.currentClass = current;
    },
    //获取验证码
    sendMsg() {
      let me = this;
      if (this.ruleForm.phone) {
        this.sendCode();
        me.isDisabled = true;
        let interval = window.setInterval(function () {
          me.buttonName = "（" + me.time + "秒）";
          --me.time;
          if (me.time < 0) {
            me.buttonName = "重新发送";
            me.time = 10;
            me.isDisabled = false;
            window.clearInterval(interval);
          }
        }, 1000);
      } else {
        this.$message.error("请先输入手机号");
        me.isDisabled = false;
      }
    },
    //失效重新获取二维码
    refreshQr() {
      this.getqrcode();
      this.isShow = false;
    },
    //获取二维码
    getqrcode() {
      getqrcode().then((res) => {
        if(res.code == 800){
          this.qrcodeUrl = res.data.qrcode;
          this.sceneId = res.data.scene_id;
          this.invalid = res.data.expire;
          const timer = setInterval(() => {
            checklogin({ scene_id: this.sceneId }).then((res) => {
              if (res.msg == "扫码成功") {
                clearInterval(timer);
                this.qrcode = false;
                if (res.data.userinfo.isbangding === false) {
                  this.userInfoDia = true;
                  this.userInfoId = res.data.userinfo.id;
                } else {
                  let token = res.data.sign;
                  // let userInfo = res.data.userinfo;
                  let userInfo = JSON.stringify(res.data.userinfo);

                  Cookies.set("token", token, { expires: 1 });
                  Cookies.set("userInfo", userInfo, { expires: 1 });
                  this.qrcode = false;
                  this.userInfoDia = false;
                  this.showUser = true;
                  location.reload();
                }
              }
            });
          }, 1000);
        }
      });
    },
    //验证码登录获取验证码
    sendCode() {
      sendcode({ phone: this.ruleForm.phone, type: "login" }).then((res) => {
        console.log(res);
      });
    },
    //验证码登录
    loginCode() {
      if (this.ruleForm.phone && this.ruleForm.verifi) {
        codelogin({
          phone: this.ruleForm.phone,
          code: this.ruleForm.verifi,
        }).then((res) => {
          if (res.code == 800) {
            let token = res.data.sign;
            let userInfo = res.data.userinfo;
            Cookies.set("token", token, { expires: 1 });
            Cookies.set("userInfo", userInfo, { expires: 1 });
            this.qrcode = false;
            this.userInfoDia = false;
            this.showUser = true;
            location.reload();
          }
        });
      }
    },
    //账号密码登录
    accountLogin() {
      if (this.ruleForm.account && this.ruleForm.pass) {
        passlogin({
          phone: this.ruleForm.account,
          password: this.ruleForm.pass,
        }).then((res) => {
          console.log(res);
          if (res.code == 800) {
            let token = res.data.sign;
            let userInfo = res.data.userinfo;
            Cookies.set("token", token, { expires: 1 });
            Cookies.set("userInfo", userInfo, { expires: 1 });
            this.qrcode = false;
            this.userInfoDia = false;
            this.showUser = true;
            location.reload();
          }
        });
      }
    },
    open() {
      this.qrcode = true;
      this.interval = setInterval(() => {
        this.invalid--;
        if (this.invalid === 0) {
          clearInterval(this.interval);
          this.isShow = true;
        }
      }, 1000);
      this.getqrcode();
    },
    //完善信息获取验证码
    sendMsg2() {
      let me = this;
      if (this.ruleFormUser.phone) {
        this.sendCode2();
        me.isDisabled = true;
        let interval = window.setInterval(function () {
          me.buttonName2 = "（" + me.time + "秒）";
          --me.time;
          if (me.time < 0) {
            me.buttonName2 = "重新发送";
            me.time = 10;
            me.isDisabled = false;
            window.clearInterval(interval);
          }
        }, 1000);
      } else {
        this.$message.error("请先输入手机号");
        me.isDisabled = false;
      }
    },
    //完善信息登录获取验证码
    sendCode2() {
      sendcode({ phone: this.ruleFormUser.phone, type: "register" }).then((res) => {
        console.log(res);
      });
    },
    //点击已有账号
    userDia() {
      this.userInfoDia = false;
      this.qrcode = true;
    },
    //完善信息
    subInfo() {
      
      saveinfo({
        id: this.userInfoId,
        nick: this.ruleFormUser.nickName,
        phone: this.ruleFormUser.phone,
        code: this.ruleFormUser.verifi,
        password: this.ruleFormUser.passWord,
        confirmpass: this.ruleFormUser.conPass,
        shareuid:this.shareuid
      }).then((res) => {
        console.log(res);
        if (res.code == 800) {

          // this.writeinfo = true;//填写编辑个人资料
          let token = res.data.sign;
          let userInfo = res.data.userinfo;
          Cookies.set("token", token, { expires: 1 });
          Cookies.set("userInfo", userInfo, { expires: 1 });
          this.qrcode = false;
          this.userInfoDia = false;
          this.showUser = true;

          //登录完成后刷新页面
          location.reload();
            
        }
      });
    },
  },
};
</script>
<style lang="scss">
/* 自定义宽度 */
.my-el-select {
    width: 260px;
    /* selecte 框的高度设置，默认是 40px*/
    .el-input__inner{
        height: 32px;
    }
    /* 下面设置右侧按钮居中 */
    .el-input__suffix {
        top: 2px;
    }
    .el-input__icon {
        line-height: inherit;
    }
    .el-input__suffix-inner {
        display: inline-block;
    }
}
.my-input .el-input__inner{
      width: 260px;
      height: 32px;
  }

.my-textarea .el-textarea__inner{
  width:260px;
  height: 100px;
}

.profile .el-dialog__header{
  display: none;
}

</style>

<style scoped lang="scss">
/deep/ .el-dialog{
  width: 400px;
  height: 500px;
}
.login-wrap {
  .text-tips {
    text-align: center;
    span {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
    }
  }
  .opration-btn {
    display: flex;
    justify-content: space-around;
    margin-top: 150px;
    .item {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 22px;
        height: 22px;
        margin-right: 10px;
      }
      span {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
.tab {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%);
}
.tab_con {
  padding: 0 30px;
}
.tab_button {
  width: 340px;
  padding: 0;
}
.tab_button li {
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  color: #888;
  text-align: center;
  margin-left: 25px;
}

.tab_button li.active {
  color: #ff7919;
}
.qrcode-wrap {
  position: relative;
  width: 179px;
  height: 179px;
  margin: 0 auto;
  margin-bottom: 30px;
  img {
    width: 100%;
    height: 100%;
  }
  .qrcode-modal {
    width: 179px;
    height: 179px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: 0.4;
    .refresh-btn {
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -20px 0 0 -20px;
    }
  }
}
.text-tips {
  text-align: center;

  img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    vertical-align: middle;
  }
  span {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }
}

.el-form-item {
  border-bottom: 1px solid #e2e2e2;
}

.el-form-item >>> .el-form-item__error {
  padding-left: 15px;
}

.profile .el-form-item{
  border:none;
  margin-bottom: 10px;
}

.login_jump{
  width: 130px;
  height: 40px;
  font-size: 16px;
  border: 1px solid #FF7919;
  border-radius: 4px;
  color: #FF7919;
  margin-left: -10px;
}
.login-btn2 {
  width: 130px;
  height: 40px;
  font-size: 16px;
  background: #FF7919;
  border-radius: 4px;
  margin-top: 30px;

}
.login-btn {
  display: block;
  width: 290px;
  height: 40px;
  color: #fff;
  background-color: #ff7919;
  border-color: #ff7919;
  margin: 0 auto;
  margin-top: 30px;
}
.getVerifi {
  position: absolute;
  right: 0;
  color: #ff7919;
}
.jump {
  width: 114px;
  height: 114px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 100;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.title-tips {
  width: 140px;
  height: 31px;
  background: #fff;
  border: 1px solid #2fbe96;
  border-radius: 4px;
  position: absolute;
  right: 60px;
  top: 10px;
  text-align: center;
  line-height: 31px;
  color: #333;
  font-size: 12px;
  display: none;
}
.title-tips::after {
  content: "";
  width: 10px;
  height: 10px;
  background: #fff;
  border-top: 1px solid #2fbe96;
  border-right: 1px solid #2fbe96;
  position: absolute;
  right: -6px;
  top: 9.5px;
  transform: rotate(45deg);
}
.jump:hover {
  .title-tips {
    display: block;
  }
}

.profile .head{
  display: block;
  width: 73px;
  height: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin:0 auto;
  }

.profile .headtip{
  display: block;
  width: 181px;
  height: 13px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin:12px auto;
}


</style>
